import { Link } from 'react-router-dom';

const Industries = () => (
  <>
  <section className="pt-[240px] px-[120px] pb-0 grid [grid-template-columns:repeat(2,_minmax(0,_1fr))] gap-20 items-end tablet:px-6 tablet:[grid-template-columns:1fr] tablet:pt-[116px]">
    <div className="flex flex-col gap-7 tablet:min-w-0">
      <p className="m-0 text-[16px] text-mx-accent-light tracking-[0.04em] font-display">
        Industries
      </p>
      <h1 className="m-0 font-medium text-[72px] leading-[1.04] tracking-[-0.02em] font-display tablet:text-[44px] tablet:leading-[1.08]">
        Where our parts go to work
      </h1>
    </div>
    <p className="m-0 text-[20px] leading-[1.65] text-mx-copy tablet:min-w-0">
      Three industries, one way of working: built to your print at vetted partner plants, inspected to U.S. standards and delivered duty-paid.
    </p>
  </section>
  <section className="pt-[120px] px-[120px] pb-0 flex flex-col gap-10 tablet:px-6">
    <Link to="/oil-gas" className="grid [grid-template-columns:repeat(2,_minmax(0,_1fr))] bg-mx-card border border-mx-border rounded-3xl overflow-hidden tablet:[grid-template-columns:1fr]">
      <img src="/media/images/oil-gas-wellsite.jpg" alt="Drilling rig at dusk with threaded steel tubulars racked in the foreground" loading="lazy" className="h-[380px] rounded-none border-0 block w-full object-cover tablet:min-w-0" />
      <div className="p-14 flex flex-col justify-center gap-4 tablet:min-w-0">
        <h2 className="m-0 font-semibold text-[40px] leading-[1.1] font-display tablet:text-[32px]">
          Oil & Gas
        </h2>
        <p className="m-0 text-[18px] leading-[1.6] text-mx-copy">
          Perforating gun carriers, endplates, bulkheads, feedthroughs and connectors for wireline and completion tools.
        </p>
        <span className="mt-2 font-semibold text-mx-accent-light font-display">
          View oil & gas
        </span>
      </div>
    </Link>
    <Link to="/data-centers" className="grid [grid-template-columns:repeat(2,_minmax(0,_1fr))] bg-mx-card border border-mx-border rounded-3xl overflow-hidden tablet:[grid-template-columns:1fr]">
      <div className="p-14 flex flex-col justify-center gap-4 tablet:min-w-0">
        <h2 className="m-0 font-semibold text-[40px] leading-[1.1] font-display tablet:text-[32px]">
          Data Centers
        </h2>
        <p className="m-0 text-[18px] leading-[1.6] text-mx-copy">
          Supports, enclosures, cable management, duct bank materials and custom parts for every phase of the build.
        </p>
        <span className="mt-2 font-semibold text-mx-accent-light font-display">
          View data centers
        </span>
      </div>
      <img src="/media/images/data-hall.jpg" alt="Data hall under construction" loading="lazy" className="h-[380px] rounded-none border-0 block w-full object-cover tablet:min-w-0" />
    </Link>
    <Link to="/industrial" className="grid [grid-template-columns:repeat(2,_minmax(0,_1fr))] bg-mx-card border border-mx-border rounded-3xl overflow-hidden tablet:[grid-template-columns:1fr]">
      <img src="/media/images/turned-part.jpg" alt="CNC-turned stainless steel part" loading="lazy" className="h-[380px] rounded-none border-0 block w-full object-cover tablet:min-w-0" />
      <div className="p-14 flex flex-col justify-center gap-4 tablet:min-w-0">
        <h2 className="m-0 font-semibold text-[40px] leading-[1.1] font-display tablet:text-[32px]">
          Industrial & Process Equipment
        </h2>
        <p className="m-0 text-[18px] leading-[1.6] text-mx-copy">
          Machined, cast, stamped and molded parts for OEMs building heaters, pumps, compressors, valves and machinery.
        </p>
        <span className="mt-2 font-semibold text-mx-accent-light font-display">
          View industrial equipment
        </span>
      </div>
    </Link>
  </section>
  <section className="mt-[140px] mx-[120px] mb-0 py-[72px] px-20 bg-mx-accent rounded-[28px] flex justify-between items-center gap-12 tablet:px-6 tablet:mx-4 tablet:flex-wrap">
    <div className="flex flex-col gap-3 text-mx-ink">
      <h2 className="m-0 font-semibold text-[44px] leading-[1.1] font-display tablet:text-[32px]">
        Don't see your industry?
      </h2>
      <p className="m-0 text-[18px] leading-[1.6] max-w-[620px]">
        If the part has a drawing, we can quote it. Tell us what you build.
      </p>
    </div>
    <Link to="/contact" className="inline-flex items-center min-h-14 px-8 py-0 rounded-[999px] bg-mx-ink text-white font-semibold text-[16px] whitespace-nowrap font-display">
      Request a quote
    </Link>
  </section>
  </>
);
export default Industries;
